import Vue from "vue";
import VueRouter from "vue-router";
import VueMeta from "vue-meta";
import routes from "./routes";
import store from "../state/store";

Vue.use(VueRouter);
Vue.use(VueMeta, {
  // The component option name that vue-meta looks for meta info on.
  keyName: "page",
});

const router = new VueRouter({
  routes,
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: {
          x: 0,
          y: 80,
        },
        behavior: "smooth",
      };
    } else if (to.path == from.path) {
      return {
        x: 0,
        y: 0,
      };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0,
      };
    }
  },
});

// function sleep(ms) {
//   return new Promise((resolve) => setTimeout(resolve, ms));
// }

router.beforeEach(async (to, from, next) => {
  // SSO destination flow needs to bypass every other guard — a logged-in
  // user from another tab must still be allowed to land on /sso/landing
  // (verify-inbound will force-terminate their old session before minting
  // a new one). Same for the /sso/error page so failures route cleanly.
  if (to.matched.some(r => r.meta.bypassAuth)) {
    next();
    return;
  }

  const redirectAfterLogout = localStorage.getItem("redirectAfterLogout");
  if (redirectAfterLogout) {
    localStorage.removeItem("redirectAfterLogout");
    next(redirectAfterLogout);
    return;
  }
  const isAuth = store.getters["authen/getUser"] || store.getters["govAuthen/isAuthenticate"];

  if (to.matched.some(r => r.meta.guestOnly) && isAuth) {
    next("/main");
    return;
  }
  const govAuth = await store.dispatch("govAuthen/setUserFromToken");
  if (to.matched.some(r => r.meta.requiresGovAuth)) {
    if (!(govAuth || !!store.getters["authen/getUser"])) {
      return next({
        name: "governmentLogin"
      });
    }
  }
  if (
    govAuth &&
    to.matched.some(r => r.meta.requiresAuth) &&
    !to.matched.some(r => r.meta.requiresGovAuth)
  ) {
    return next("/main");
  }
  // if (to.name === "governmentLogin" && store.getters["govAuthen/isAuthenticate"]) {
  //   next("/main");
  //   return;
  // }
  if (store && !store.getters["authen/getUser"]) {
    await store.dispatch("authen/fetchAccessToken", { isRefresh: false });
  }

  const userRole = store.getters["authen/getRoles"];
  const redirectUrl = sessionStorage.getItem("redirectUrl");
  const userData = store.getters["authen/getUser"];
  const isAuthenticate = !!localStorage.getItem("isAuthenticate");
  // if (to.name === "LoginV2" && store.getters["authen/getUser"]) {
  //   next("/main");
  //   return;
  // }
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (govAuth) {
      next();
      return;
    }
    
    if (userData) {
      if (
        userRole.some((role) => to.meta.allowRoles.some((allowRoles) => allowRoles === role)) ||
        (to.meta.allowRoles.some((allowRoles) => allowRoles === "vendor_business_owner") && userRole.length === 0)
      ) {
        if (redirectUrl && redirectUrl !== "/loginv2") {
          sessionStorage.removeItem("redirectUrl");
          next(redirectUrl);
          return;
        }
        if (redirectUrl) {
          sessionStorage.removeItem("redirectUrl");
        }
        next();
        return;
      } else {
        next("/main");
        return;
      }
    } else {
      next({ name: "LoginV2", query: { redirectUrl: to.fullPath } });
      return;
    }
  } else {
    if (redirectUrl) {
      sessionStorage.removeItem("redirectUrl");
      sessionStorage.removeItem("firstLoginSession");
      window.location.href = redirectUrl
      return;
    }
    if (sessionStorage.getItem("firstLoginSession") == "1" && userData && !isAuthenticate) {
      sessionStorage.removeItem("firstLoginSession");
      store.commit("authen/setIsAuthenticate", true)
      if (userData && userRole.length === 0) {
        router.push({
          name: "AddSME",
        });
        return;
      } else if (userRole.includes("admin_approver_level1") || userRole.includes("admin_approver_level2") || userRole.includes("super_admin")) {
        router.push({
          name: "Pre Approve",
        });
        return;
      } else if (userRole.includes("oss_officer")){
        router.push({
          name: "Report",
        });
        return;
      } else if (userRole.includes("data_analyst")) {
        window.location.href = "https://thaismegp.sme.go.th/viz/"
        return;
      }
      /*else if (userRole.includes("admin_approver_level2")) {
        router.push({
          name: "Approve",
        });
        return;
      } else if (userRole.includes("super_admin")) {
        router.push({
          name: "Approve",
        });
        return;
      }*/
     else {
        next();
        return;
      }
    }

    next();
    return;
  }
});

export default router;
